<mbs-sidepanel
  id="global_downloads"
  [headerClass]="'-light'"
  [hideSave]="true"
  [innerContentType]="'tabs'"
  [isCreate]="false"
  [large]="true"
  [showDelete]="false"
  [showExpandedCross]="true"
  (panelOpened)="panelOpened()">
  <div
    class="mbs-sidepanel_title"
    header-title>
    <div class="mbs-sidepanel_title-ico">
      <span
        *ngIf="!isBuilding"
        class="fa fa-download"></span>
      <span
        *ngIf="isBuilding"
        class="loader loader-lg loader-primary"></span>
    </div>
    <div class="mbs-sidepanel_title-name">
      {{ 'shared:sidePanelDownloads.header' | i18next: { format: 'title' } }}
    </div>
  </div>
  <ng-container body>
    <ng-container *ngIf="(buildList | async)?.length; else loader">
      <div
        class="mbs-sidepanel_tabset -vertical"
        id="global_downloads_body"
        [ngStyle]="{ 'max-width.px': '680' }">
        <ul
          #activeContent="mbsTabset"
          mbsTabset
          mode="vertical"
          [loadOnAppearance]="false"
          (beforeUpdate)="onTabUpdate($event)">
          <li
            *ngFor="let item of tabItems"
            [mbsTabsetItem]="item.id">
            <div
              mbsTabsetLink
              role="button"
              [attr.data-e2e]="elementSelectors.name[item.id]?.tabBlockBtn">
              <div
                class="form-row h-100"
                [attr.data-e2e]="elementSelectors.name[item.id]?.tabBlock">
                <div class="col-auto d-flex align-items-center">
                  <span
                    *ngIf="item.icon"
                    [attr.data-e2e]="elementSelectors.name[item.id]?.tabIcon"
                    [class]="item.icon"></span>
                  <div class="tab-icon d-inline-flex align-items-center justify-content-center">
                    <img
                      *ngIf="item.image"
                      [alt]="item.title"
                      [attr.data-e2e]="elementSelectors.name[item.id]?.tabImage"
                      [src]="item.image"
                      [width]="item.imageWidth ?? 22" />
                  </div>
                </div>
                <div class="col">
                  <div class="form-row position-relative">
                    <div
                      class="col"
                      [class.app-update-dot]="(newVersionsAlerts$ | async)?.[item.updateAlert]">
                      <span
                        class="fw-semibold"
                        [attr.data-e2e]="elementSelectors.name[item.id]?.tabTitle"
                        >{{ item.title }}</span
                      >
                    </div>
                  </div>
                  <div
                    *ngIf="item.beta"
                    class="form-row">
                    <div class="col">
                      <span class="text-cyan text-xs">{{ 'shared:beta' | i18next: { format: 'title' } }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <ng-container [ngSwitch]="item.id">
              <ng-template
                *ngSwitchCase="agentType.Backup"
                mbsTabsetContent>
                <ng-container
                  [ngTemplateOutlet]="tabContent"
                  [ngTemplateOutletContext]="{ builds: (backupBuilds$ | async), type: agentType.Backup }"></ng-container>
              </ng-template>

              <ng-template
                *ngSwitchCase="agentType.RMM"
                mbsTabsetContent>
                <ng-container
                  [ngTemplateOutlet]="tabContent"
                  [ngTemplateOutletContext]="{ builds: (rmmBuilds$ | async), type: agentType.RMM }"></ng-container>
              </ng-template>

              <ng-template
                *ngSwitchCase="agentType.RA"
                mbsTabsetContent>
                <ng-container
                  [ngTemplateOutlet]="tabContent"
                  [ngTemplateOutletContext]="{ builds: (raBuilds$ | async), type: agentType.RA }"></ng-container>
              </ng-template>

              <ng-template
                *ngSwitchCase="'bootableUSB'"
                mbsTabsetContent>
                <div class="mbs-sidepanel_content-inner">
                  <ng-container *ngTemplateOutlet="bootableUSBDescription"></ng-container>

                  <div class="d-flex justify-content-between">
                    <div class="d-flex align-items-center">
                      <span
                        aria-hidden="true"
                        class="d-inline-block"
                        [style.-webkit-mask]="'url(assets/images/icons/bootable-usb.svg) no-repeat center / contain'"
                        [style.background-color]="'var(--mbs-text)'"
                        [style.height.px]="22"
                        [style.mask]="'url(assets/images/icons/bootable-usb.svg) no-repeat center / contain'"
                        [style.width.px]="22">
                      </span>

                      <span class="ml-2">{{ 'products.bootableUSB' | i18next: { format: 'title' } }}</span>
                    </div>

                    <mbs-button
                      type="primary"
                      [attr.data-e2e]="elementSelectors.name.bootableUSB.createBtn"
                      (click)="onOpenQuickRestoreButtonClick()"
                      >{{ 'shared:buttons.create' | i18next }}</mbs-button
                    >
                  </div>
                </div>

                <ng-template #bootableUSBDescription>
                  <p class="mb-3">
                    {{ 'shared:sidePanelDownloads.createBootableUSBDescription' | i18next }}
                    <a
                      *ngIf="'HelpMarketing' | can: 'read'"
                      href="/AP/Help/restore/quick-restore"
                      target="_blank">
                      {{ 'shared:sidePanelDownloads.learnMore' | i18next }}
                    </a>
                  </p>
                </ng-template>
              </ng-template>

              <ng-template
                *ngSwitchCase="agentType.NetworkDiscovery"
                mbsTabsetContent>
                <ng-container
                  [ngTemplateOutlet]="tabContent"
                  [ngTemplateOutletContext]="{ builds: (ndBuilds$ | async), type: agentType.NetworkDiscovery, beta: true }"></ng-container>
              </ng-template>

              <ng-template
                *ngSwitchCase="'guides'"
                mbsTabsetContent>
                <div class="mbs-sidepanel_content-inner">
                  <mbs-guides-tab></mbs-guides-tab>
                </div>
              </ng-template>
            </ng-container>
          </li>

          <li
            *ngIf="isSettingsButtonVisible"
            class="mt-auto"
            mbsTabsetItem="options">
            <mbs-button
              mbsTabsetLink
              [align]="'left'"
              [block]="true"
              [customClasses]="'mbs-tabset_link py-1 pl-0'"
              [isCtrl]="true">
              <span class="form-row align-items-center">
                <span class="col-auto">
                  <span class="ico ico-Gear h3 m-0 p-0"></span>
                </span>
                <span class="col lh-1">{{ 'shared:buttons.options' | i18next: { format: 'title' } }}</span>
              </span>
            </mbs-button>
            <ng-template mbsTabsetContent>
              <form
                class="m-3 border rounded bg-gray-5"
                [formGroup]="settingsForm">
                <div class="m-3">
                  <mbs-switcher
                    formControlName="isSandboxEnabled"
                    labelPosition="left"
                    [boldLabel]="true"
                    [disableControl]="isBuilding"
                    [disableControlOptions]="{ emitEvent: false }"
                    [expandLabel]="true"
                    [label]="'shared:sidePanelDownloads.options.sandbox' | i18next"
                    [subtitle]="'shared:sidePanelDownloads.options.sandboxDescription' | i18next"></mbs-switcher>
                </div>

                <hr />

                <div class="m-3">
                  <mbs-switcher
                    formControlName="isAutoGenerateEnabled"
                    labelPosition="left"
                    [boldLabel]="true"
                    [disableControl]="isBuilding"
                    [disableControlOptions]="{ emitEvent: false }"
                    [expandLabel]="true"
                    [label]="'shared:sidePanelDownloads.options.autoGenerate' | i18next"
                    [subtitle]="'shared:sidePanelDownloads.options.autoGenerateDescription' | i18next"></mbs-switcher>
                </div>

                <hr />

                <div class="m-3">
                  <mbs-switcher
                    formControlName="isAutoUpdateEnabled"
                    labelPosition="left"
                    [boldLabel]="true"
                    [descriptionOutside]="true"
                    [disableControl]="isBuilding"
                    [disableControlOptions]="{ emitEvent: false }"
                    [expandLabel]="true"
                    [label]="'shared:sidePanelDownloads.options.automaticUpdate' | i18next">
                    <ng-template switcherDescription>
                      <div
                        class="mbs-form-text small mt-0"
                        [class.text-disabled]="isBuilding">
                        {{ 'shared:sidePanelDownloads.options.automaticUpdateDescription' | i18next }}
                        <a
                          *ngIf="'HelpMarketing' | can: 'read'"
                          href="/AP/Help/automation/agent-update"
                          target="_blank"
                          [class.text-disabled]="isBuilding">
                          {{ 'shared:buttons.learnMore' | i18next }}
                        </a>
                      </div>
                    </ng-template>
                  </mbs-switcher>
                </div>

                <div class="m-3">
                  <mbs-input-label
                    [boldLabel]="true"
                    [label]="'shared:sidePanelDownloads.options.exclude' | i18next"
                    [labelClasses]="isBuilding ? 'text-disabled' : ''">
                  </mbs-input-label>

                  <div>
                    <mbs-button
                      [disabled]="!settingsForm.get('isAutoUpdateEnabled').value || isBuilding"
                      [isCtrl]="true"
                      (click)="selectComputers()">
                      {{ updateDisabledCountText }}
                    </mbs-button>
                  </div>
                </div>
              </form>
            </ng-template>
          </li>
        </ul>

        <div
          class="position-relative"
          [mbsTabsetOutlet]="activeContent"
          [overlay]="currentCopingStatus === copyingStatus.Copying"></div>
      </div>
    </ng-container>

    <ng-template #loader>
      <mbs-loader></mbs-loader>
    </ng-template>
  </ng-container>
</mbs-sidepanel>

<ng-template
  #tabContent
  let-beta="beta"
  let-builds="builds"
  let-type="type"
  [templateTyping]="tabContentToken">
  <div class="mbs-sidepanel_content-inner">
    <mbs-alert
      *ngIf="isBuilding"
      [icon]="true"
      [size]="alertSize.sm"
      [type]="alertType.info">
      {{ 'shared:builds.generating_alert' | i18next }}
    </mbs-alert>

    <mbs-alert
      *ngIf="allowSpecificBuild && (type === agentType.Backup || type === agentType.RMM || type === agentType.RA)"
      [icon]="true"
      [type]="alertType.info">
      <div class="row">
        <div class="col-11 pr-0">
          {{ 'shared:sidePanelDownloads.specificDownload.text' | i18next }}
          <a
            href="#"
            [attr.data-e2e]="elementSelectors.name[type]?.tabTitle"
            (click)="specificDownloadClick($event, type)"
            >{{ 'shared:sidePanelDownloads.specificDownload.link' | i18next }}</a
          >
        </div>
        <div class="col-1 text-end">
          <mbs-button
            icon="ico ico-Close"
            type="dark"
            [attr.data-e2e]="elementSelectors.name[type]?.specificCloseBtn"
            [isCtrl]="true"
            [size]="alertSize.xs"
            (click)="specificDownloadClose()"></mbs-button>
        </div>
      </div>
    </mbs-alert>

    <ng-container *ngIf="type !== agentType.RA; else raTemplate">
      <p
        *ngIf="type === agentType.NetworkDiscovery"
        class="mb-0">
        {{ 'shared:sidePanelDownloads.networkDiscoveryDescription' | i18next }}
        <a
          *ngIf="'HelpMarketing' | can: 'read'"
          href="/AP/Help/downloads/discover-deploy-tool"
          target="_blank"
          [attr.data-e2e]="elementSelectors.name[type]?.helpLink">
          {{ 'shared:sidePanelDownloads.learnMore' | i18next }}
        </a>
      </p>

      <ng-container *ngFor="let build of builds; let i = index">
        <section
          [ngClass]="{
            'py-4': !!i && i !== builds.length - 1,
            'pt-2 pb-4': !i,
            'pt-4 pb-2': i === builds.length - 1,
            'border-bottom': i !== builds.length - 1
          }">
          <mbs-download-build
            [beta]="beta"
            [build]="build"
            [buildsInProgress]="buildsInProgress"
            [currentUser]="currentUser"
            [index]="i"
            [isSandboxEnabled]="isSandboxEnabled"
            [licensedBrandList]="licensedBrandList"
            [openedPanelIds]="openedPanelIds"
            [showDeleteButton]="type !== agentType.NetworkDiscovery"
            [type]="type"
            (buildPanelClick)="onBuildPanelClick($event)"
            (removeBuild)="onRemoveBuildHandle()"></mbs-download-build>
        </section>
      </ng-container>
    </ng-container>

    <ng-template #raTemplate>
      <mbs-download-connect></mbs-download-connect>
    </ng-template>
  </div>
</ng-template>
